var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ElButton,{staticClass:"social-button",class:{
    'social-button_disabled': _vm.disabled,
    'social-button_attached': _vm.attached,
  },attrs:{"data-test-id":"button","loading":_setup.loading || _vm.attaching,"plain":_vm.plain || _vm.attaching || _vm.attached},on:{"click":function($event){return _setup.emit('open-scope')}}},[_c('div',{staticClass:"social-button__inner"},[(!_setup.loading)?_c('div',{staticClass:"social-button__icon",attrs:{"data-test-id":"social-icon"}},[_vm._t("icon")],2):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }